export enum ProPnlEvents {
  ProPnlCTA = 'proPnLCta',
  ProPnlPageView = 'pro/pnl',
  PnlCurrencySelected = 'pnlCurrencySelected',
  PnlCumulativeInfoCTA = 'pnlCumulativeInfoCta',
  PnlDailyInfoCTA = 'pnlDailyInfoCta',
  PnlHistoryDownloadCTA = 'pnlHistoryDownloadCta'
}

export type PnlEvents = ProPnlEvents;
